import { partitionArray } from 'helpers'

import Flexer from 'js/components/Flexer/Flexer'
import Tag from 'js/components/Tag/Tag'

interface CloudProps {
    tagCategory: {
        name: string
        values: string[]
    }
    value: string[]
    onChange: (value: string[]) => void
}

const Cloud = ({ tagCategory, value = [], onChange }: CloudProps) => {
    const tags = tagCategory.values
    const [selectedTags, unselectedTags] = partitionArray(tags, (tag: string) =>
        value.includes(tag),
    )

    const removeTag = (tag: string) => {
        const newValues = value.filter((t) => t !== tag)
        onChange(newValues)
    }

    const addTag = (tag: string) => {
        const newValues = [...value, tag]
        onChange(newValues)
    }

    return (
        <>
            <Flexer
                justifyContent="flex-start"
                gutter="none"
                style={{
                    flexWrap: 'wrap',
                    gap: 4,
                    marginBottom: selectedTags.length ? 12 : 0,
                }}
            >
                {selectedTags.map((tag) => {
                    return (
                        <Tag key={tag} onRemove={() => removeTag(tag)}>
                            {tag}
                        </Tag>
                    )
                })}
            </Flexer>

            <Flexer
                justifyContent="flex-start"
                gutter="none"
                style={{ flexWrap: 'wrap', gap: 4 }}
            >
                {unselectedTags.map((tag) => {
                    return (
                        <Tag key={tag} as="button" onClick={() => addTag(tag)}>
                            {tag}
                        </Tag>
                    )
                })}
            </Flexer>
        </>
    )
}

export default Cloud
